import { render, staticRenderFns } from "./RcWidgetLiveResultsBody.vue?vue&type=template&id=7bb88583&"
import script from "./RcWidgetLiveResultsBody.vue?vue&type=script&lang=js&"
export * from "./RcWidgetLiveResultsBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports